var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal", attrs: { heading: "Pass Applicant" } }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("h5", [
        _vm._v(
          "You are moving this candidate to Start, would you like to Send this Candidate to Sage?"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
      _c("div", { staticClass: "cell shrink" }, [
        _vm.enableSendToSage
          ? _c(
              "button",
              {
                staticClass: "button",
                attrs: { type: "button" },
                on: { click: _vm.passSendToSage }
              },
              [_vm._v("Send to Sage")]
            )
          : _c(
              "button",
              {
                staticClass: "button disabled",
                attrs: {
                  disabled: "",
                  title:
                    "The job profile linked to this requisition is missing the External Req # and the Sage Req ID, please correct in order to Sync to Sage"
                }
              },
              [_vm._v("Send to Sage")]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell shrink" }, [
        _c(
          "button",
          {
            staticClass: "button warning",
            attrs: { type: "button" },
            on: { click: _vm.passOnly }
          },
          [_vm._v("No do not send to Sage, just to Start")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a28cdb4", { render: render, staticRenderFns: staticRenderFns })
  }
}